import { IBigscreenSettings, ICustomMetrics } from "../constants/interfaces";

export function computeCustomFields(bigscreenSettings: IBigscreenSettings[]): ICustomMetrics[] {
    const brandsWithCustomMetrics = bigscreenSettings.filter(settings => settings.features.indexOf("custommetrics") !== -1);
    const allCustomMetrics = brandsWithCustomMetrics.flatMap(brand => brand.customMetrics || []);
    return Object.values(
        allCustomMetrics.reduce<Record<string, ICustomMetrics>>((acc, metric) => {
            acc[metric.id] = metric;
            return acc;
        }, {})
    );
}

export default computeCustomFields;
